import React from 'react';
import { Palette } from 'lucide-react';

const themes = [
  { id: 'blue', color: '#76b9ff', label: 'Blå' },
  { id: 'green', color: '#50dc78', label: 'Grön' },
  { id: 'purple', color: '#b388ff', label: 'Lila' },
  { id: 'red', color: '#ff6b6b', label: 'Röd' },
  { id: 'pink', color: '#ff79c6', label: 'Rosa' },
];

export default function ThemeSwitcher({ currentTheme, setTheme }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '10px 12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '7px', color: 'var(--text-muted)', fontSize: '11px', fontWeight: 650, letterSpacing: '.8px', textTransform: 'uppercase' }}>
        <Palette size={14} /> Tema
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        {themes.map(t => (
          <div
            key={t.id}
            onClick={() => setTheme(t.id)}
            title={t.label}
            style={{
              width: '22px', height: '22px', borderRadius: '50%', cursor: 'pointer',
              background: t.color,
              border: currentTheme === t.id ? '2.5px solid #fff' : '2.5px solid transparent',
              boxShadow: currentTheme === t.id ? `0 0 10px ${t.color}88` : 'none',
              transition: 'all 0.2s',
              transform: currentTheme === t.id ? 'scale(1.15)' : 'scale(1)',
            }}
          />
        ))}
      </div>
    </div>
  );
}
